module.exports = __webpack_public_path__ + "img/log.7e87550.svg";